/**
 * Created by olga on 10.07.2026
 */

const ScissorsComponentView = function (component, unitView) {
    this.component = component;
    this.unitView = unitView;

    this.dimmed = [];
    this.undimmed = [];
    this.targetAnimations = [];
};

ScissorsComponentView.prototype.highlightDrag = function () {
    this.unHighlightDrag();

    Merge2.current.field.iterateUnits((x, y, unit) => {
        if (unit === this.component.unit) {
            return;
        }

        const unitView = unit.onGetView();
        if (!unitView) {
            return;
        }

        if (this.component.isCuttable(unit)) {
            this.createTargetAnimation(unitView);

            const generator = unit.findComponent(Merge2Generator);
            if (generator) {
                generator.setDimmingDisabled(true);
                this.undimmed.push(unit);
            }
            return;
        }

        if (!unit.findComponent(ScissorsComponent) && !unit.isGrounded()) {
            unitView.setImageColor(ScissorsComponentView.DIMMED_COLOR);
            this.dimmed.push(unit);
        }
    });
};

ScissorsComponentView.prototype.createTargetAnimation = function (unitView) {
    const styles = cleverapps.styles.ScissorsComponentView;

    const glow = new cleverapps.Spine(bundles.merge_animations.jsons.booster_target_glow_json);
    glow.setAlignment(styles.glow);
    glow.setAnimation(0, "animation", true);
    unitView.addChild(glow, -1);
    this.targetAnimations.push(glow);

    const scissors = new cleverapps.Spine(bundles.merge_animations.jsons.scissors_json);
    scissors.setAlignment(styles.scissors);
    scissors.setAnimation(0, "animation", false);
    scissors.setCompleteListenerRemove();
    unitView.addChild(scissors);
    this.targetAnimations.push(scissors);
};

ScissorsComponentView.prototype.unHighlightDrag = function () {
    const dimmed = this.dimmed;
    this.dimmed = [];

    dimmed.forEach((unit) => {
        const unitView = unit.onGetView();
        if (unitView) {
            unitView.restoreColor();
        }
    });

    const targetAnimations = this.targetAnimations;
    this.targetAnimations = [];

    targetAnimations.forEach((animation) => {
        animation.removeFromParent();
    });

    const undimmed = this.undimmed;
    this.undimmed = [];

    undimmed.forEach((unit) => {
        const generator = unit.findComponent(Merge2Generator);
        if (generator) {
            generator.setDimmingDisabled(false);
        }
    });
};

ScissorsComponentView.prototype.clearAnimations = function () {
    this.unHighlightDrag();
};

ScissorsComponentView.DIMMED_COLOR = new cc.Color(150, 150, 150, 255);

cleverapps.styles.ScissorsComponentView = {
    glow: {
        x: { align: "center" },
        y: { align: "center" }
    },

    scissors: {
        x: { align: "center" },
        y: { align: "center" }
    }
};